<template>
  <div class="m-l-50 m-t-30" v-loading="loading">
    <el-form ref="form" :model="form" class="fl p-r-10 m-r-10 bor-r-ccc" style="width:60%;">
      <el-form-item label="页面名称（标题）" prop="name">
        <el-input v-model="form.name" type="text" class="h-40 w-200" placeholder="请输入名称（标题）">
      </el-form-item>
      <el-form-item label="页面描述" prop="description">
        <el-input v-model="form.description" type="textarea" class="w-200" placeholder="请输入描述">
      </el-form-item>
      <el-form-item label="页面类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio :label="LAYOUT_FLOW">顺序布局</el-radio>
          <el-radio :label="LAYOUT_FLOW_TAB">顺序-TAB布局</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="主题样式" prop="theme">
        <el-select v-model="form.theme">
          <el-option v-for="theme in themeList" :label="theme.title" :value="theme.theme"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="功能组件配置" prop="parts">
        <parts-table
          :parts-data="form.partsConfig"
          :models-by-id="modelsById"
          @setCurPart="setCurPart"
          @deletePart="deletePart"></parts-table>
        <div class="m-t-10 tx-c">
          <el-button type="primary" @click="addPart">添加</el-button>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save()" :loading="isLoading">提交</el-button>
        <el-button @click="goback()">返回</el-button>
      </el-form-item>
    </el-form>
    <right-config v-if="showConfig" :models="models" :form="curConfig" @openRule="openRule" class="fl"></right-config>
    <rule-list ref="ruleList" @selectRule="selectRule" title="权限规则绑定"></rule-list>
  </div>
</template>
<script>
  import http from 'assets/js/http'
  import mobileConfig from 'config/mobileConfig'
  import ruleList from '../../Common/business/rule.vue'
  import partsTable from './partsTable.vue'
  import rightConfig from './rightConfig.vue'

  export default {
    props: {
      id: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        loading: false,
        isLoading: false,
        form: {
          name: '',
          description: '',
          type: null,
          theme: '',
          partsConfig: [] // 功能组件配置
        },
        part: {
          name: '',
          position: null,
          type: null,
          model_id: '',
          rule_name: '',
          sort: ''
        },
        curConfig: null, // 当前配置项
        models: [], // 表单列表
        modelsById: {} // 表单id为key的对象
      }
    },
    created() {
      this.getModels()
      if (this.id) {  // 编辑
        this.getDetail(this.id, false)
      }
    },
    methods: {
      /**
       * 编辑页面获取详情
       */
      getDetail() {
        this.loading = true
        this.apiGet(`mobile/page/get/${this.id}`).then((res) => {
          this.form = this.promiseHandler({}, res)
          this.loading = false
        })
      },
      /**
       * 获取表单列表
       */
      getModels() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('form/models', postData).then((res) => {
          if (res.code == 200) {
            this.models = res.data.list
            let modelsById = {}
            _(this.models).forEach((item) => {
              modelsById[item.id] = item.title
            })
            this.modelsById = modelsById
          } else {
            _g.dealError(this, res)
          }
        })
      },
      /**
       * 重新设置当前右侧配置（配置行切换）
       */
      setCurPart(item) {
        this.curConfig = item
      },
      deletePart(index) {
        this.form.partsConfig.splice(index, 1)
      },
      /**
       * 添加功能组件配置
       */
      addPart() {
        this.form.partsConfig.push(_.cloneDeep(this.part))
      },
      openRule(item) {  // 打开绑定权限弹窗
        // this.curObj = item
        this.$refs.ruleList.open()
      },
      // 选择权限
      selectRule(id, title_else, title) {
        // this.curObj.rule_id = id
        // this.curObj.rule_name = title_else
        this.curConfig.rule_id = id
        this.curConfig.rule_name = title_else
      },
      save() {
        if (this.id) {
          this.edit()
        } else {
          this.add()
        }
      },
      edit() {
        this.isLoading = true
        let postData = _.cloneDeep(this.form)
        this.apiPut(`mobile/page/save/${this.id}`, '', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功！')
            _g.updateMenus()
            setTimeout(() => {
              this.goback()
            }, 1000)
          } else {
            _g.dealError(this, res)
            this.isLoading = false
          }
        })
      },
      add() {
        this.isLoading = true
        let postData = _.cloneDeep(this.form)

        this.apiPost('mobile/page/save', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功！')
            _g.updateMenus()
            setTimeout(() => {
              this.goback()
            }, 1000)
          } else {
            _g.dealError(this, res)
            this.isLoading = false
          }
        })
      },
      goback() {
        router.go(-1)
      }
    },
    computed: {
      showConfig() {
        return !!this.curConfig
      }
    },
    components: {
      ruleList,
      partsTable,
      rightConfig
    },
    mixins: [http, mobileConfig]
  }
</script>


// WEBPACK FOOTER //
// form.vue?6aa2e349